<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer015">
<p class="dedication" lang="en-US"><span class="Italic-Style" lang="en-US">To Cheryl Ann</span></p>
<p class="dedication" lang="en-US"><span class="Italic-Style" lang="en-US">who rescued Maia from Flatland</span></p>
<p class="dedication" lang="en-US"><span class="Italic-Style" lang="en-US">and me from loneliness</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504086356.vue?781dd8c2